// import { explorerPlugin } from "@graphiql/plugin-explorer";
import { createGraphiQLFetcher } from "@graphiql/toolkit";
import { Auth } from "aws-amplify";
import { GraphiQL } from "graphiql";
// import 'graphiql/graphiql.css';
import "graphiql/graphiql.min.css";
import { useEffect, useState } from "react";
import "./document.css";

const Document = () => {
  const [token, setToken] = useState("");
  const getToken = async () => {
    const tokenValue = (await Auth.currentSession()).getIdToken().getJwtToken();
    setToken(tokenValue);
  };
  useEffect(() => {
    getToken();
  }, []);
  // console.log('token', token);
  const url = process.env.REACT_APP_GRAPHQL_ENDPOINT;

  const fetcher = createGraphiQLFetcher({
    url,
    headers: {
      // "x-api-key": process.env.REACT_APP_API_KEY,
      authorization: token,
    },
  });
  return <GraphiQL fetcher={fetcher} />;
};

export default Document;
